import { setGeoJSONData } from './setGeoJSONData.js';

export function setGeoJSONLayerData(data) {
  return setGeoJSONData(this, data);
}
